<div
  class="bag-drawer"
  [class.is-open]="cartService.isDrawerOpen()"
  [attr.aria-hidden]="!cartService.isDrawerOpen()"
>
  <button class="bag-drawer__backdrop" type="button" aria-label="Close bag" (click)="close()"></button>
  <aside class="bag-drawer__panel" role="dialog" aria-modal="true" aria-label="Bag">
    <app-bag variant="drawer" />
  </aside>
</div>
